import { useObjectsState } from "../contexts/ObjectsProvider";

export function useAnimatedObject(objectId?: string) {
  const { animatedObjects } = useObjectsState();
  //TODO animatedObjectsCache for useMemo
  return animatedObjects.find((object) => object.id === objectId);
}
